import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { TxReporting } from '@fortem-monorepo/web-sdk'

import { useUserContext } from '@/index'
import { toastApiError } from '@/lib/error-toast'
import { queryKeys } from '@/react-query/queries/tx-reporting/keys'

export const useUpdateTxReportMutation = (report_date: string) => {
  const api = useApi()

  const client = useQueryClient()

  return useMutation({
    mutationFn: (params: TxReporting.UpdateTxReportBody) => api.txReporting.updateReport(params),
    onSuccess: (_data, params, _context) => {
      toast.success(`Updated ${params.updatedField} from ${params.newValue}.`)
    },
    onSettled: (_data, _error, _params) => {
      client.invalidateQueries({ queryKey: queryKeys.report(report_date) })
    },
  })
}

export const useSendTxReportEmailMutation = () => {
  const api = useApi()

  const { user } = useUserContext()

  return useMutation({
    mutationFn: (params: TxReporting.SendTxReportEmailParams) => api.txReporting.sendEmail(params),
    onSuccess: () => {
      toast.success(`Email sent to ${user.user?.email}`)
    },
  })
}

export const useResetTxReportRowMutation = (report_date: string) => {
  const api = useApi()

  const client = useQueryClient()

  return useMutation({
    mutationFn: (params: TxReporting.ResetTxReportBody) => api.txReporting.resetRow(params),
    onSuccess: (_data, params, _context) => {
      toast.success(`Successfully reset ${params.trade_id}.`)
    },
    onError: (error, params, _context) => {
      toastApiError(error, `Error resetting ${params.trade_id}.`)
    },
    onSettled: (_data, _error, _params) => {
      client.invalidateQueries({ queryKey: queryKeys.report(report_date) })
    },
  })
}
